var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"productSection",class:{
    'productSection--titlePadding': _vm.paddingOnlyTitle,
    'productSection--mobileFull': _vm.mobileFull,
    'productSection--disableMobileBg': _vm.disableMobileBackground,
    'productSection--disableMarginBottom': _vm.disableMarginBottom,
  }},[(_vm.title)?_c('div',{staticClass:"productSection__title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n    "),(_vm.hTag)?[_c('br'),_vm._v(" "),_c(_vm.hTag ? 'h2' : 'span',{tag:"component",staticClass:"productSection__titleName"},[_vm._v(_vm._s(_vm.productName)+"\n      ")])]:_vm._e()],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }